module.exports = __webpack_public_path__ + "img/instagram.2679dcde.svg";